// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Tri3","title":"Info_title__3zomH","selects":"Info_selects__1wsp8","requiredAsterisk":"Info_requiredAsterisk__tJM9U"};